import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { LOGO_URL } from "@/data/branding";
import { trackEvent } from "@/lib/analytics";
import SocialLinks from "@/components/SocialLinks";

const links = [
  { to: "/", label: "Home", testid: "nav-home" },
  { to: "/specials", label: "Specials", testid: "nav-specials" },
  { to: "/tires", label: "Tires", testid: "nav-tires" },
  { to: "/financing", label: "Financing", testid: "nav-financing" },
  { to: "/news", label: "News", testid: "nav-news" },
  { to: "/faq", label: "FAQ", testid: "nav-faq" },
  { to: "/#services", label: "Services", testid: "nav-services" },
  { to: "/#schedule", label: "Schedule", testid: "nav-schedule" },
];

export default function SiteHeader() {
  const [open, setOpen] = useState(false);

  return (
    <header className="site-header">
      <div className="site-social-bar">
        <div className="container site-social-bar-inner">
          <span className="site-social-bar-tag">Follow us:</span>
          <SocialLinks variant="icons" size="sm" />
        </div>
      </div>
      <div className="container nav">
        <Link to="/" className="brand" data-testid="brand-home-link" aria-label="Auto Basic Care home">
          <img src={LOGO_URL} alt="Auto Basic Care" className="brand-logo" />
          <div>
            <div className="brand-title">Auto Basic Care</div>
            <div className="brand-subtitle">Birmingham Auto Repair</div>
          </div>
        </Link>

        <nav className="desktop-nav" aria-label="Main navigation">
          {links.map((l) =>
            l.to.startsWith("/#") ? (
              <Link key={l.label} to={l.to} data-testid={l.testid}>{l.label}</Link>
            ) : (
              <NavLink key={l.label} to={l.to} data-testid={l.testid}>{l.label}</NavLink>
            )
          )}
          <a href="tel:2054051238" className="btn btn-dark" data-testid="nav-phone-btn" onClick={() => trackEvent("Contact", { source: "header" })}>205-405-1238</a>
        </nav>

        <button
          className="mobile-menu-button"
          onClick={() => setOpen((o) => !o)}
          aria-label="Open mobile menu"
          data-testid="mobile-menu-toggle"
        >
          ☰
        </button>
      </div>

      <nav className={`mobile-nav ${open ? "open" : ""}`} aria-label="Mobile navigation">
        {links.map((l) =>
          l.to.startsWith("/#") ? (
            <Link key={l.label} to={l.to} data-testid={`m-${l.testid}`} onClick={() => setOpen(false)}>{l.label}</Link>
          ) : (
            <NavLink key={l.label} to={l.to} data-testid={`m-${l.testid}`} onClick={() => setOpen(false)}>{l.label}</NavLink>
          )
        )}
        <a href="tel:2054051238" data-testid="m-nav-phone-btn" onClick={() => { setOpen(false); trackEvent("Contact", { source: "mobile-nav" }); }}>Call 205-405-1238</a>
      </nav>
    </header>
  );
}
